import React from 'react';

const HyperLinksList = () => {
  return (
    <div className="items">
      <div>
        <p className="editorial-large semibold mb-md">
          HyperLinks (
          <a
            className="editorial-large semibold underline"
            href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=18870-1257&m=dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            Reference
          </a>
          )
        </p>
        <p className="caption mb-xl">
          Example usage: <code className="code-example">class="body-text-link"</code>
        </p>
      </div>
      <div className="column section-wrap">
        {/* Main Nav */}
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Main Nav / Rest
          </p>
          <a className="main-nav-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Main Nav / Focus, Active, Hover
          </p>
          <a className="main-nav-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        {/* Large Sub Nav */}
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Large Sub Nav / Rest
          </p>
          <a className="large-sub-nav-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Large Sub Nav / Focus, Active, Hover
          </p>
          <a className="large-sub-nav-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        {/* Body Text Link  */}
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Body Text Link / Rest
          </p>
          <a className="body-text-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Body Text Link / Hover
          </p>
          <a className="body-text-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        {/* Body Text Link Small */}
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Body Text Link Small / Rest
          </p>
          <a className="body-text-link-small" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Body Text Link Small / Hover
          </p>
          <a className="body-text-link-small" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        {/* Banner Link */}
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Banner Link / Rest
          </p>
          <a className="banner-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
        <div className="section">
          <p className="body" style={{ width: 210, margin: 0 }}>
            Banner Link / Hover
          </p>
          <a className="banner-link" href="/" rel="noopener noreferrer">
            Navigation
          </a>
        </div>
      </div>
    </div>
  );
};

export default HyperLinksList;
